const HIDDEN_DEFAULT_STOCK_SYMBOLS_KEY = "hiddenDefaultStockSymbols";

function plainObject(value) {
  return value && typeof value === "object" && !Array.isArray(value) ? value : null;
}

function parsedPreferenceRecord(value) {
  if (plainObject(value)) return value;
  if (typeof value !== "string" || !value.trim()) return null;
  try {
    return plainObject(JSON.parse(value));
  } catch {
    return null;
  }
}

export function hasCanonicalHiddenDefaultStocksField(value) {
  const record = parsedPreferenceRecord(value);
  return Boolean(
    record && Object.prototype.hasOwnProperty.call(record, HIDDEN_DEFAULT_STOCK_SYMBOLS_KEY),
  );
}

/**
 * Keep an absent canonical field absent while upgrading legacy browser rows.
 *
 * `normalizePreferences` exposes a convenient empty-string default to callers,
 * but serializing that default would falsely claim canonical authority and
 * discard the legacy watchlist document's hidden country defaults.
 */
export function preferenceStoragePayload(normalized, currentRaw, options = {}) {
  const source = plainObject(normalized) || {};
  const payload = { ...source };
  const persistHiddenDefaultStocks =
    options.persistHiddenDefaultStocks === true || hasCanonicalHiddenDefaultStocksField(currentRaw);
  if (!persistHiddenDefaultStocks) {
    delete payload[HIDDEN_DEFAULT_STOCK_SYMBOLS_KEY];
  }
  return payload;
}
